<air-title [title]="content.title" [region]="region" [isFirst]="isFirst"></air-title>
<expandable-list [userEventSource]="userEventSource">
  <ng-container *ngFor="let text of content.texts">
    <expandable-list-item [title]="text.title">
      <div [internalInnerHtml]="text.body" [userEventSource]="userEventSource"></div>
      <div class="text-list-feedback" *ngIf="content.enableFeedback">
        <div class="text-list-feedback__collapse">
          <div class="text-list-feedback__header">{{ "text-list.label.feedback" | translate }}</div>
          <div class="text-list-feedback__buttons">
            <button class="button button--secondary button--feedback" (click)="handleVote(text.title, 'upvote', $event)">
              <i class="icon icon-ui-upvote"></i>
            </button>
            <button class="button button--secondary button--feedback" (click)="handleVote(text.title, 'downvote', $event)">
              <i class="icon icon-ui-downvote"></i>
            </button>
          </div>
        </div>
      </div>
    </expandable-list-item>
  </ng-container>
</expandable-list>
